import { useState, useEffect } from "react";
import { ScreenSize } from "../types/ScreenSizes";

export type Breakpoints = {
    width: number;
    isMobile: boolean;
    isTablet: boolean;
    isDesktopSmall: boolean;
    isDesktopMedium: boolean;
    isDesktopLarge: boolean;
};

export function useBreakpoint(): Breakpoints {
    const [width, setWidth] = useState(() => {
        if (typeof window === "undefined") return 0;
        return Math.round(window.visualViewport?.width ?? window.innerWidth);
    });

    useEffect(() => {
        const update = () => {
            const nextWidth = Math.round(window.visualViewport?.width ?? window.innerWidth);
            setWidth(nextWidth);
        };

        update();
        const raf = window.requestAnimationFrame(update);

        window.addEventListener("resize", update);
        window.addEventListener("orientationchange", update);
        window.visualViewport?.addEventListener("resize", update);

        return () => {
            window.cancelAnimationFrame(raf);
            window.removeEventListener("resize", update);
            window.removeEventListener("orientationchange", update);
            window.visualViewport?.removeEventListener("resize", update);
        };
    }, []);

    return {
        width,
        isMobile: width < ScreenSize.MOBILE,
        isTablet: width >= ScreenSize.MOBILE && width < ScreenSize.TABLET,
        isDesktopSmall: width >= ScreenSize.TABLET && width < ScreenSize.LAPTOP,
        isDesktopMedium:
            width >= ScreenSize.LAPTOP && width < ScreenSize.DESKTOP,
        isDesktopLarge: width >= ScreenSize.DESKTOP,
    };
}
